import { render } from "./PosMenu.vue?vue&type=template&id=550264dd"
import script from "./PosMenu.vue?vue&type=script&lang=js"
export * from "./PosMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__